module.exports = __webpack_public_path__ + "static/media/hamburger.4e465722.png";